import React from "react";
import { Box, GridItem, Heading, VStack, Text } from "@chakra-ui/react";
import { Form, TextInput, Grid } from "components";
import { useCurrentCase } from "duck";
import { Address } from "./components";
import { hooks, utils, Types } from "./duck";

const ClientInformation: React.FC = () => {
  const defaultValues = useCurrentCase(medicalCase =>
    utils.getClientInformation(medicalCase.data)
  );

  const update = hooks.useUpdateClient();

  return (
    <Box mt={12}>
      <Heading color="black" fontSize="18px">
        Client Information
      </Heading>
      <Form<Types.FormValues>
        mt={4}
        validationSchema={utils.getValidationSchema()}
        defaultValues={defaultValues}
      >
        <Form.Watcher defaultValues={defaultValues} onChange={update} />
        <Grid
          templateColumns={{
            base: "1fr",
            sm: "repeat(2, 1fr)"
          }}
        >
          <GridItem>
            <TextInput
              name="accountNumber"
              label="Account Number"
              placeholder="Account Number"
            />
          </GridItem>

          <GridItem>
            <TextInput
              name="email"
              label="Email Address"
              placeholder="Email Address"
            />
          </GridItem>

          <GridItem>
            <TextInput
              name="firstName"
              label="First Name"
              placeholder="First Name"
            />
          </GridItem>

          <GridItem>
            <TextInput
              name="lastName"
              label="Last Name"
              placeholder="Last Name"
            />
          </GridItem>

          <Address />

          <GridItem>
            <TextInput
              name="phoneFirst"
              label="Phone Number 1"
              placeholder="Phone Number 1"
            />
          </GridItem>

          <GridItem>
            <TextInput
              name="phoneSecond"
              label="Phone Number 2"
              placeholder="Phone Number 2"
            />
          </GridItem>

          <GridItem colSpan={2}>
            <VStack>
              <Text color="black" fontWeight="medium">
                Since your pet will be under anesthesia, it is critical that we
                are able to reach you to discuss further treatment if deemed
                necessary by the doctor. Is there any time you will NOT be
                available?
              </Text>
              <TextInput
                label="Time Unavailable"
                labelHidden
                name="notAvailableTime"
                placeholder="Time"
              />
            </VStack>
          </GridItem>
        </Grid>
      </Form>
    </Box>
  );
};

export default ClientInformation;
